"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDescriptor__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "baseURI",
                type: "string",
            },
        ],
        name: "BaseURIUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "DataURIToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "PartsLocked",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_background",
                type: "string",
            },
        ],
        name: "addBackground",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_body",
                type: "bytes",
            },
        ],
        name: "addBody",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_color",
                type: "string",
            },
        ],
        name: "addColorToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_glasses",
                type: "bytes",
            },
        ],
        name: "addGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_head",
                type: "bytes",
            },
        ],
        name: "addHead",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "_backgrounds",
                type: "string[]",
            },
        ],
        name: "addManyBackgrounds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_bodies",
                type: "bytes[]",
            },
        ],
        name: "addManyBodies",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string[]",
                name: "newColors",
                type: "string[]",
            },
        ],
        name: "addManyColorsToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_glasses",
                type: "bytes[]",
            },
        ],
        name: "addManyGlasses",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_heads",
                type: "bytes[]",
            },
        ],
        name: "addManyHeads",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_skills",
                type: "bytes[]",
            },
        ],
        name: "addManySkills",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_skill",
                type: "bytes",
            },
        ],
        name: "addSkill",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "arePartsLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "backgroundCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "backgrounds",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "bodies",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bodyCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "skill",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "skill",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "generateSVGImage",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "skill",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "genericDataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "glasses",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "glassesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "headCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "heads",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDataURIEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockParts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "palettes",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "skillCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "skills",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDataURIEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "skill",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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__$e1d8844a0810dc0e87a665b1f2b5fa7c69$__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__$e1d8844a0810dc0e87a665b1f2b5fa7c69$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
class NounsDescriptor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, NounsDescriptor__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$e1d8844a0810dc0e87a665b1f2b5fa7c69\\$__", "g"), linkLibraryAddresses["contracts/libs/NFTDescriptor.sol:NFTDescriptor"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDescriptor__factory = NounsDescriptor__factory;
NounsDescriptor__factory.bytecode = _bytecode;
NounsDescriptor__factory.abi = _abi;
